module.exports = __webpack_public_path__ + "img/ep-E-dosis.00d6bb96.jpg";